import { Typography } from "ui/typography/typography";
import { STATUS_LABEL_VARIANT } from "ui/status/status.constants";
import { StatusDot, StatusRoot } from "ui/status/status.styles";
import { type StatusProps } from "ui/status/status.types";

export const Status = ({ type, size = "medium", label, ...rest }: StatusProps) => (
  <StatusRoot statusSize={size} {...rest}>
    <StatusDot aria-hidden statusSize={size} statusType={type} />
    <Typography color="inherit" component="span" variant={STATUS_LABEL_VARIANT[size]}>
      {label}
    </Typography>
  </StatusRoot>
);
